let config = {
  'title': '远大前程',
  'keywords': '远大前程',
  'description': '远大前程，QQ浏览器桌面版用户专享'
};

config.layout = require('@layout/single');

require('./index.css');

config.qbtop = [
  require('@tencent/pcqb-act-header')
];

config.qbheader = [];

config.qbbody = [
  require('@modules/lottery'),
  require('@modules/video_info_answer'),
  require('@modules/video_recommend')
];

config.qbfooter = [
  require('@tencent/pcqb-act-footer')
];

module.exports = config;



// WEBPACK FOOTER //
// ./pages/index/config.js